import api_config from '@/api/config/_api_config'

// PORT-001 : capacités RS256 de 120 s émises par be_config (audience clinicaa-portail).
// Réponse : { success: true, data: { access_token, expires_in, expires_at, actor_id } }.
// Le jeton reste dans la requête de l'appelant : jamais dans le store ni dans localStorage.
export default {
    getAccesPortail() {
        return api_config().post('/portail/access', {}, { med_access_scoped: true, timeout: 20000 }).then(response => response.data)
    },
    getAccesPassagePortail() {
        return api_config().post('/portail/passage-access', {}, { med_access_scoped: true, timeout: 20000 }).then(response => response.data)
    }
}
